export default "__VITE_ASSET__BDiABcXO__"